import { CallAPIPostPromise } from "Common/commaon";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import apiUrl from "slices/apiEndpoint";
import { selectToken } from "slices/auth/login/reducer";
import { getDecodeId } from "slices/userProfile/thunk";
export const trackEvent = async (eventName, meta = {}, screen = "",token) => {
  try {
    await fetch(`${apiUrl}/dashboard/event/track`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        event_name: eventName,
        screen_name: screen,
        metadata: meta,
        userId :getDecodeId()
      })
    });
  } catch (e) {
    // silently ignore (never block UX)
  }
};

const CreditCardProcessing = () => {
 const navigate= useNavigate()
 const token = useSelector(selectToken)
  useEffect(()=>{
window.open("https://www.deluxe.com/mkt/referrals/ttc-usa/","blank")
navigate("/")
trackEvent("Credit-card-processing", {}, "credit_card_processing",token)
  },[])
  return (
    <div className="page-content" style={{ height: "100vh" }}>
      <iframe
        src="https://www.deluxe.com/mkt/referrals/ttc-usa/"
        width="100%"
        height="100%"
        loading="lazy"
        allowFullScreen
        style={{ border: "none" }}
        title="Credit Card Processing"
      />
    </div>
  );
};

export default CreditCardProcessing;
